import React, { FC } from 'react';
import LeftPanel from './components/LeftPanel';
import CreateAccountForm from './components/CreateAccountForm';
import { Link } from 'react-router-dom';

const CreateAccount: FC = () => (
  <div className="flex flex-col lg:flex-row h-screen">
  <LeftPanel />

  {/* Right side */}
  <div className="w-full lg:w-1/2 p-6 sm:p-8 lg:p-10 flex flex-col">
    {/* Center content */}
    <div className="flex-1 flex flex-col items-center justify-center">
      <div className="w-full md:w-[640px] lg:w-[500px] xl:w-[460px] flex flex-col items-center justify-center">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl xl:text-4xl font-semibold mb-1">
          Create Account
        </h2>
        <p className="text-sm text-gray-500 mb-6">Register to continue using Website</p>

        <CreateAccountForm />
      </div>
    </div>

    {/* Bottom link */}
    <div className="mt-auto">
      <p className="text-center text-button text-black mt-4">
        Already have an account?{" "}
        <Link to="/login" className="text-[#14D8CE] hover:underline">
          Sign In
        </Link>
      </p>
    </div>
  </div>
</div>

);

export default CreateAccount;
